/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
//import { Dropdown1 } from '../../../../../../_metronic/partials/content/dropdown/Dropdown1'
import { Loading } from '../../../../components/Loadings/loading'
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan'
import { SearchInput } from '../../../../components/SearchInput'
import { FormPlantsNotImported } from './formPlantsNotImported'
import { useAuth } from '../../../../../modules/auth'
import { ModalConfigurationsImported } from './modalConfigurationsImported'
import clsx from 'clsx'
import { PlanUsage, PlanUsageWarning } from './planUsageImported'
//import {KTSVG, toAbsoluteUrl} from '../../../helpers'
//import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string,
  plants: any[],
  loading: boolean,
  addValuesData: any,
  submit: any,
  loadingSubmit: any;
  unit_branchs: any[]
  plantsComposite: any[]
  addValuesDataAll: any
  addValuesDataAllStatus: any
  plantsImported: any[]
  addValuesDataAllTypeImportation: any
  addValuesDataAllPlantComposite: any
  dataGlobal: any
  setDataGlobal: any
  refreshPlants: any
  bloqueadQtdComposite: boolean;
  selectedPlanUsage: PlanUsage | undefined
  newSelected: number
  exceededPlan: boolean
}

const TablePlantNotImported: React.FC<Props> = ({
  className, 
  plants, 
  loading, 
  addValuesData, 
  submit, 
  loadingSubmit, 
  unit_branchs,
  plantsComposite,
  addValuesDataAll,
  addValuesDataAllStatus,
  plantsImported,
  addValuesDataAllTypeImportation,
  addValuesDataAllPlantComposite,
  dataGlobal,
  setDataGlobal,
  refreshPlants,
  bloqueadQtdComposite,
  selectedPlanUsage,
  newSelected,
  exceededPlan
}) => {
  const [data, setData] = useState<any>([]);
  const [mySearch, setMySearch] = useState([]);
  const [control, setControl] = useState(false);
  const [inputControl, setInputControl] = useState(false);
  const [largura, setLargura] = useState(window.innerWidth);
  const [showCreateAppModalImport, setShowCreateAppModalImport] = useState<boolean>(false)



  const updateData = (idPlant : string | number, check: boolean) => {

    setData((prevData: any) => {
      if (check) {
        if (!prevData.includes(idPlant)) {
          return [...prevData, idPlant];
        }
      } else {
        return prevData.filter((plant: any) => plant !== idPlant);
      }
      return prevData; 

    });
    addValuesData(idPlant, check)
  }

  const updateDataUnitBranch = (idUnitBranch: string) => {
    addValuesDataAll(idUnitBranch)
  }

  const checkedAll = (check: boolean) =>{
    if(check === true){
      plants.map((plant: any) => {
        if(typeof plant.plantId === "string"){
          updateData(plant.plantId.toString(), true)
        }else{
          updateData(Number(plant.plantId), true)
        }
        
      })
    }else{
      plants.map((plant: any) => {
        if(typeof plant.plantId === "string"){
          updateData(plant.plantId.toString(), false)
        }else{
          updateData(Number(plant.plantId), false)
        }
      })
    }
  }

  const atualizarTamanhoDaTela = () => {
    setLargura(window.innerWidth);
  };

  useEffect(() => {
    if(plants.length > 0 && plants.length  === data.length){
      setInputControl(true)
    }else{
      setInputControl(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    window.addEventListener('resize', atualizarTamanhoDaTela);
    return () => {
      window.removeEventListener('resize', atualizarTamanhoDaTela);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`card ${className}`} style={{paddingRight: '1rem', paddingTop: largura < 1200 ? '1rem' : ''}}>

      <div className='card-header border-0 mt-xl-9' style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '1rem'}}>
        <div style={{display: "flex", justifyContent: 'space-between', alignItems: 'center'}}>
          <h3 style={{display: "flex", flexDirection: "column"}}>
              <span className='card-label fw-bold fs-3'>Usinas - Não Importadas <KTSVG path="/media/icons/duotune/arrows/arr015.svg" className="svg-icon-danger svg-icon-2hx" /></span>
              <span className='text-muted mt-1 fw-semibold fs-7'><span style={{fontWeight: '800'}}>Total:</span> {plants.length} usinas <span style={{fontWeight: '800'}}>não importadas</span></span>
          </h3>

          {newSelected > 0 && (
            <span className='badge badge-light-primary fs-7 fw-bold px-3 py-2'>
              {newSelected} selecionada{newSelected === 1 ? '' : 's'}
            </span>
          )}
        </div>

        <PlanUsageWarning plan={selectedPlanUsage} newSelected={newSelected} />

        <div 
          className='card-toolbar' 
          style={{
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            flexWrap: 'wrap',
            paddingRight: '0.3rem',
            gap: '1rem'
            }}
          >
            <div className='position-relative' style={{flex: '1 1 220px'}}>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-4'
              />
              <SearchInput 
                className='form-control form-control-solid ps-12'
                placeholder='Buscar usina'
                myDate={plants}
                setMySearch={setMySearch}
                control={control}
                setControl={setControl}
                disabled={loading || loadingSubmit ? true : false}
                searchParameter="plantName"
                style={{width: '100%'}}
              />
            </div>

            {/* paddingRight alinha o checkbox com os checkboxes da lista de usinas abaixo */}
            <label
              className={clsx(
                'form-check form-check-custom form-check-solid rounded ps-4 py-3 m-0',
                inputControl ? 'bg-light-primary' : 'bg-light'
              )}
              style={{gap: '0.75rem', paddingRight: '1.35rem', cursor: loading || loadingSubmit ? 'not-allowed' : 'pointer'}}
            >
              <span className={clsx('fw-semibold fs-6', inputControl ? 'text-primary' : 'text-gray-700')}>Selecionar todas</span>
              <input 
                className={`form-check-input ${inputControl ? 'bg-primary' : 'bg-dark'}`}
                type='checkbox'
                disabled={loading || loadingSubmit}
                checked={inputControl}
                onChange={(e) =>{
                  checkedAll(e.target.checked)
                  setInputControl(e.target.checked)
                }} 
              />
            </label>
        </div>
      </div>
      {
        loading 
        ? 
          (
            <div className='card-body pt-2' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <h3 style={{display: "flex", flexDirection: "column"}}>
                <Loading myClass='spinner-border text-secondary'/>
                {/* <span className='text-muted mt-1 fw-semibold fs-7'>Carregando...</span> */}
              </h3>
            </div>
          ) 
        : 
          plants.length > 0 ?
            (<div 
              className='card-body pt-5' 
              style={{
                overflowY: "auto", 
                height: '25rem',
                margin: "1rem 0rem 1rem 0rem"
              }}
            >
                <FormPlantsNotImported 
                  plants={control === false ? plants : mySearch} 
                  updateData={updateData} 
                  inputGlobal={inputControl}
                  plants_list={dataGlobal.plants_list}
                  loadingSubmit={loadingSubmit}
                />
              </div>)
          :
            <div className='card-body pt-2' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <h3 style={{display: "flex", flexDirection: "column"}}>
                <span className='text-muted mt-1 fw-semibold fs-7'>Não há usinas importadas.</span>
              </h3>
            </div> 
      }

      {/* end::Body */}
      <div className='card-footer' style={{display: 'flex', justifyContent: largura < 1200 ? '' : 'space-between', flexWrap: 'wrap', gap: '1rem'}}>
        {/* <div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem'}}>
        {
          <select
            style={{width: largura < 1200 ? '100%' : '20rem'}}
            className='form-select form-select-solid'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            defaultValue={'1'}
            onChange={(e) =>
              updateDataUnitBranch(e.target.value)
            }
          >
            <option value={'1'}>Escolha uma unidade</option>
            {unit_branchs && unit_branchs.map((myUnitBranch: any) => {
              return (
                <option key={myUnitBranch.id} value={myUnitBranch.id}>{myUnitBranch.companyName}</option>
              )
            })}
          </select>
        }
        {
          <select
            style={{width: largura < 1200 ? '100%' : '20rem'}}
            className='form-select form-select-solid'
            data-kt-select2='true'
            data-placeholder='Select option'
            data-allow-clear='true'
            defaultValue={''}
            onChange={(e) =>
              addValuesDataAllStatus(e.target.value)
            }
          >
            <option value={''} disabled>Selecione um plano</option>
            {
              currentUser 
              && currentUser.companies 
              && currentUser.companies.length > 0 
              && currentUser.companies[0].planosCompany
              && currentUser.companies[0].planosCompany.qtd_plants_plano > 0
              && (
                <option value={'PREMIUM'}>PREMIUM</option>
              )
            }
            {
              currentUser 
              && currentUser.companies 
              && currentUser.companies.length > 0 
              && currentUser.companies[0].planosCompany
              && currentUser.companies[0].planosCompany.qtd_plants_plano_starter > 0
              && (
                <option value={'STARTER'}>STARTER</option>
              )
            }

{
              currentUser 
              && currentUser.companies 
              && currentUser.companies.length > 0 
              && currentUser.companies[0].planosCompany
              && currentUser.companies[0].planosCompany.qtd_plants_gratuita > 0
              && (
                <option value={'BASICA'}>BÁSICA</option>
              )
            }

          </select>
        }

        </div> */}

        <div 
          className='dropdown' 
          style={{display: 'flex', gap: '0.5rem', width: 'auto', paddingRight: '0.5rem', alignItems: 'center'}}
        >
          <div 
            style={{display: 'flex', gap: '0.5rem', width: 'auto'}}
            className='btn btn-sm btn-icon btn-active-color-primary border-bottom-0 border-top-0 border-left-0 text-muted text-hover-primary '
            onClick={()=> {
              setShowCreateAppModalImport(true)
            }}
            // data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            // data-kt-menu-attach='parent'
            // data-kt-menu-placement="bottom-end"

            // data-bs-toggle='collapse'
            // data-bs-target={`#kt_account_profile_details_configuration`}
            // aria-expanded='true'
            // aria-controls={`kt_account_profile_details_configuration`}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/coding/cod001.svg' />
            <h3 
              className='card-title align-items-start flex-column'
            >
              <span className='mt-1 fw-semibold fs-5'>Configurações de importação</span>
            </h3>
          </div>

          <span 
            style={{marginLeft: '0.5rem', cursor: 'pointer'}}
            id="dropdownMenuButton7" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
            data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            data-kt-menu-attach='parent'
            className='text-hover-primary'
          >
            <i className="bi bi-caret-down-fill fs-7"></i>
          </span>

          <div 
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary dropdown-menu dropdown-menu-start fw-bold fs-6 w-400px py-4' 
            aria-labelledby="dropdownMenuButton7" 
            style={{padding: '1rem'}}
          >
            <div>Configurações de importação</div>
            <div className='border-top' style={{paddingTop: '1rem'}}>
              <div className='d-flex flex-column content-justify-center flex-row-fluid'>
                  <div className='d-flex fw-semibold align-items-center'>
                      <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
                      <div className={`text-gray-500 flex-grow-1 me-4 fs-8`}>Tipo de importação</div>
                      <div className={`fw-bolder text-gray-700 text-xxl-end fs-8`}>
                          <span>{dataGlobal.type_importation ? dataGlobal.type_importation : ""}</span>
                      </div>
                  </div>

                  {dataGlobal.type_importation && dataGlobal.type_importation === "COMPOSTA" &&
                    <div className='d-flex fw-semibold align-items-center my-3'>
                      <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
                      <div className={`text-gray-500 flex-grow-1 me-4 fs-8`}>Usina COMPOSTA</div>
                      <div className={`fw-bolder text-gray-700 text-xxl-end fs-8`}>
                        <span>
                          {dataGlobal.idParentPlant
                            ? plantsComposite.find(p => p.id === dataGlobal.idParentPlant)?.plantName || ""
                            : ""}
                        </span>
                      </div>
                    </div>
                  }


                  <div className='d-flex fw-semibold align-items-center my-3'>
                      <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
                      <div className={`text-gray-500 flex-grow-1 me-4 fs-8`}>Unidade FILIAL</div>
                      <div className={`fw-bolder text-gray-700 text-xxl-end fs-8`}>
                          <span>
                            {dataGlobal.idUnitBranch
                              ? unit_branchs.find(unitBranch => unitBranch.id === dataGlobal.idUnitBranch)?.companyName || ""
                              : ""
                            }
                          </span>
                      </div>
                  </div>

                  <div className='d-flex fw-semibold align-items-center'>
                      <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
                      <div className={`text-gray-500 flex-grow-1 me-4 fs-8`}>Tipo de usina</div>
                      <div className={`fw-bolder text-gray-700 text-xxl-end fs-8`}>
                        <span>{dataGlobal.type_plano ? dataGlobal.type_plano : ""}</span>
                      </div>
                  </div> 
              </div>
            </div>
          </div>
        </div>
        

        <button
          type='button'
          disabled={
            bloqueadQtdComposite || 
            exceededPlan || 
            loadingSubmit || 
            !dataGlobal.idUnitBranch || 
            (dataGlobal.type_importation === "COMPOSTA" && !dataGlobal.idParentPlant) 
              ? true 
              : data.length === 0 ? true : false}
          className='btn btn-bg btn-primary'
          style={{width: largura < 1200 ? '100%' : ''}}
          //data-kt-stepper-action='submit'
          onClick={submit}
        >
          Importar{' '}
          {
            loadingSubmit ? 
              <LoadingSpan style={{marginLeft: '0.5rem'}}/>
            :
            <KTSVG
              path='/media/icons/duotune/arrows/arr064.svg'
              className='svg-icon-3 ms-2 me-0'
            />
          }
        </button>
      </div>

      <ModalConfigurationsImported 
        show={showCreateAppModalImport}
        
        addValuesDataAll={updateDataUnitBranch}
        addValuesDataAllStatus={addValuesDataAllStatus}
        addValuesDataAllTypeImportation={addValuesDataAllTypeImportation}
        addValuesDataAllPlantComposite={addValuesDataAllPlantComposite}

        dataGlobal={dataGlobal}
        setDataGlobal={setDataGlobal}

        unit_branchs={unit_branchs}
        plantsComposite={plantsComposite}

        refreshPlants={refreshPlants}

        handleClose={() => {
          setShowCreateAppModalImport(false)
          //refresh()
        }} 
      />
    </div>
  )
}

export {TablePlantNotImported}
